<template>
  <shared v-if="route.name !== 'login'">
    <Suspense>
      <router-view :key="$router.fullpath"> </router-view>
    </Suspense>
  </shared>
  <div v-else>
    <router-view :key="$router.fullpath"> </router-view>
  </div>
</template>

<script setup>
import shared from './components/shared';

import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
